import ApiClient from 'utils/api-client';

const ApiService = {
  async login(payload) {
    return ApiClient.post('auth/login', payload);
  },

  async logout() {
    return ApiClient.delete('auth/logout');
  },

  async createMember(payload) {
    return ApiClient.post('members', payload);
  },

  async fetchMembers() {
    return ApiClient.get('members');
  },

  async fetchMember(id) {
    return ApiClient.get(`members/${id}`);
  },

  async updateMember(payload) {
    const { user_id, ...data } = payload;
    return ApiClient.put(`members/${user_id}`, data);
  },

  async deleteMember(id) {
    return ApiClient.delete(`members/${id}`);
  },

  // Course
  async fetchCourses() {
    return ApiClient.get('courses');
  },

  async fetchCourse(id) {
    return ApiClient.get(`courses/${id}`);
  },

  async createCourse(payload) {
    return ApiClient.post('courses', payload);
  },

  async updateCourse(payload) {
    const { id, ...data } = payload;
    return ApiClient.put(`courses/${id}`, data);
  },

  async deleteCourse(id) {
    return ApiClient.delete(`courses/${id}`);
  },
};

export default ApiService;
